var pIndex = 0;
var blogApp;

var loadMoreBtn;
$(document).ready(function(){
	blogApp = $(".blog-item-container");
	if(blogApp.length == 0){
		return;
	}

	loadMoreBtn = $(".blog-load-more-btn");

	loadMoreBtn.on("click",loadMoreClick)

});

function loadMoreClick(event){
	event.preventDefault();
	pIndex++;
	var guid = blogApp.attr("data-guid");
	var url = blogApp.attr("data-blog-api-url");

	loadMoreBtn.addClass("hidden");

	//console.log(url + guid);

	$.ajax({
		dataType:"json",
		url:url,
		data:{guid:guid,pageIndex:pIndex},
		success:onServerData

	})
}

function onServerData(results){
	
	
	blogApp.find(".row").eq(0).append(results.Html);

	if(results.ShowButton){
		loadMoreBtn.removeClass("hidden");
	}
}


// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/blog.js